import React, { useState } from 'react';
import './App.css';
import Row from './components/Row';
import requests from './services/tmdb';
import Banner from './components/Banner';
import Navbar from './components/Navbar';
import MovieModal from './components/MovieModal';

function App() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [category, setCategory] = useState("inicio");

  return (
    <div className="app">
      <Navbar onSearch={(term) => setSearchTerm(term)} setCategory={setCategory} />
      
      {!searchTerm ? (
        <>
          {/* O Banner aparece no Início e na aba de Séries */}
          {(category === "inicio" || category === "series") && (
            <Banner onOpenModal={setSelectedMovie} />
          )}
          
          <div className="app__rows" style={{ paddingTop: category === "inicio" ? "0px" : "100px" }}>
            {/* Seção de Séries */}
            {(category === "inicio" || category === "series") && (
              <Row 
                title="Séries Originais MovieMood" 
                fetchUrl={requests.fetchNetflixOriginals} 
                onOpenModal={setSelectedMovie} 
              />
            )}
            
            {/* Seção de Filmes */}
            {(category === "inicio" || category === "filmes") && (
              <>
                <Row 
                  title="Filmes em Tendência" 
                  fetchUrl={requests.fetchTrending} 
                  onOpenModal={setSelectedMovie} 
                />
                <Row 
                  title="Mais Votados" 
                  fetchUrl={requests.fetchTopRated} 
                  onOpenModal={setSelectedMovie} 
                />
              </>
            )}
          </div>
        </>
      ) : (
        <div className="search-results" style={{paddingTop: "120px"}}>
          <Row 
            title={`Resultados para: ${searchTerm}`} 
            fetchUrl={`${requests.fetchSearch}&query=${searchTerm}`} 
            onOpenModal={setSelectedMovie} 
          />
        </div>
      )}

      {selectedMovie && (
        <MovieModal movie={selectedMovie} onClose={() => setSelectedMovie(null)} />
      )}
    </div>
  );
}

export default App;
